import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import style from './info-tooltip.module.less';

const InfoTooltip = ({ message = null }) => {
  return (
    <Tooltip>
      <div className={classnames(style['info-tooltip'], 'css-tooltip-top')}>
        <FontAwesomeIcon icon={faInfoCircle} />
      </div>
      <TooltipContent>{message}</TooltipContent>
    </Tooltip>
  );
};

InfoTooltip.propTypes = {
  message: PropTypes.node,
};

export default InfoTooltip;
